import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// eslint-disable-next-line no-empty-pattern
export const ParentContainer = styled.div(({}) => ({
    display: "flex",
    flexDirection: "column",
}));

export const EmiContainer = styled.div(({ theme }) => ({
    "& > *:first-child": {
        borderTopLeftRadius: theme.cornerRadius.medium,
        borderTopRightRadius: theme.cornerRadius.medium,
    },
    "& > *:last-child": {
        borderBottomLeftRadius: theme.cornerRadius.medium,
        borderBottomRightRadius: theme.cornerRadius.medium,
    },

    marginBottom: theme.spacing.medium,
}));

export const EmiGroupTitle = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    marginBottom: theme.spacing.small,
}));

export const Separator = styled.div(({ theme }) => ({
    borderBottom: `1px dashed ${theme.colors[theme.colorMode].border_Secondary}`,
}));
